import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import styles from './OverlayStack.module.scss';
export const OverlayStack = (param)=>{
    let { className, testId, children } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: cn(styles.overlayStack, className),
        "data-testid": testId,
        children: children
    });
};
